import { usePage } from "@/components/page/PageContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ChevronLeft, MinusIcon } from "lucide-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MembersPage from "./MembersPage";
import RulesPage from "./RulesPage";
import TeamsPage from "./TeamsPage";

const ManagePlaysPage: React.FC = () => {
  const { setTitles } = usePage();
  useEffect(() => {
    setTitles(["Manage Plays"]);
  }, []);
  const navigate = useNavigate();

  return (
    <div>
      <div className="mb-6">
        <div className="flex items-center mt-2 text-sm text-muted-foreground">
          <button
            onClick={() => {
              navigate("/plays");
            }}
            className="flex items-center text-muted-foreground hover:text-foreground p-0 h-auto font-normal"
          >
            <ChevronLeft className="h-3 w-3 mr-2" />
            <span className="text-sm">All Pain Points</span>
          </button>
          <MinusIcon className="h-3 w-3 mx-2 rotate-180" />
          <span className="text-foreground">Manage Plays</span>
        </div>
      </div>

      <Tabs defaultValue="rules" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="rules">Rules</TabsTrigger>
          <TabsTrigger value="teams">Teams</TabsTrigger>
          <TabsTrigger value="members">Members</TabsTrigger>
        </TabsList>

        <TabsContent value="rules" className="mt-4">
          <RulesPage />
        </TabsContent>

        <TabsContent value="teams" className="mt-4">
          <TeamsPage />
        </TabsContent>

        <TabsContent value="members" className="mt-4">
          <MembersPage />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ManagePlaysPage;
